<template>
  <div id="TranshipmentUnfinishedStops">
    <h6>Lista de paradas ainda não finalizadas</h6>
    <v-row class="mt-3">
      <v-col cols="12">
        <div v-if="nodes.length > 0">
          <v-progress-linear indeterminate v-show="loadingStops"></v-progress-linear>
          <table-title-row :columnsOptions="columnsStopOptions"></table-title-row>
          <template v-for="(node, nodeIndex) in nodes">
            <div :key="nodeIndex">
              <table-body-row
                :node="node"
                :nodeIndex="nodeIndex"
                :columns="columnsStops"
                :lengthDataToTruncate="20"
                :type="'Parada'"
                :enableCheckbox="true"
                :selectedCheckbox="selectedCheckbox"
                @onExpand="onExpand(node)"
                @changeCheckbox="changeSelectedCheckbox"
              >
              </table-body-row>
              <Status :nodeIndex="nodeIndex" :status="node.data.nfeStatus" />

              <v-row v-if="node.open" class="mb-2" style="margin-top: 0">
                <v-col cols="12">
                  <v-card>
                    <v-card-text class="p-5">
                      <table-title-row :columnsOptions="columnsDeliveriesOptions"></table-title-row>
                      <template v-for="(delivery, deliveryIndex) in node.children">
                        <div :key="deliveryIndex">
                          <table-body-row
                            :node="delivery"
                            :nodeIndex="deliveryIndex"
                            :stopIndex="nodeIndex"
                            :columns="columnsDeliveries"
                            :lengthDataToTruncate="16"
                            :type="'Entrega'"
                            :enableCheckbox="true"
                            :selectedCheckbox="selectedCheckbox"
                            @onExpand="onExpand(delivery)"
                            @changeCheckbox="changeSelectedCheckbox"
                          >
                          </table-body-row>
                          <Status :nodeIndex="deliveryIndex" :status="delivery.data.nfeStatus" />

                          <v-row v-if="delivery.open" style="margin-top: 0">
                            <v-col cols="12">
                              <v-card>
                                <v-card-text class="p-5">
                                  <table-title-row :columnsOptions="columnsNfeOptions"></table-title-row>

                                  <template v-for="(nfe, nfeIndex) in delivery.children">
                                    <div :key="nfeIndex">
                                      <table-body-row
                                        :node="nfe"
                                        :nodeIndex="nfeIndex"
                                        :columns="columnsNfe"
                                        :lengthDataToTruncate="16"
                                        :type="'Nota Fiscal'"
                                        :selectedCheckbox="selectedCheckbox"
                                      >
                                      </table-body-row>
                                      <Status :nodeIndex="nfeIndex" :status="nfe.data.nfeStatus" />
                                    </div>
                                  </template>
                                </v-card-text>
                              </v-card>
                            </v-col>
                          </v-row>
                        </div>
                      </template>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </template>

          <div class="mt50"></div>
          <div class="d-flex justify-space-between">
            <v-pagination v-model="page" :length="paginateTransfer.totalPages" :total-visible="7"></v-pagination>
          </div>
        </div>
        <div v-else>
          <span class="body-2 font-weight-light text--secondary"> Nenhuma parada encontrada. </span>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
import TableTitleRow from '../../components/Table/Table-Title-Row.vue';
import TableBodyRow from '../../components/Table/Table-Body-Row.vue';
import Status from '../../components/Table/Status.vue';
import changeCheckbox from '../../utils/changeSelectedCheckbox';

import maskCPF from '../../utils/maskCPF';
import maskCNPJ from '../../utils/maskCNPJ';
import maskPrice from '../../utils/maskPrice';
import maskData from '../../utils/maskData';

export default {
  name: 'TranshipmentUnfinishedStops',
  components: { TableTitleRow, TableBodyRow, Status },
  props: {
    transhipmentId: {
      default: () => null,
      type: String
    }
  },
  data: () => ({
    loadingStops: false,
    selectedCheckbox: [],
    columnsStops: ['type', 'cityName', 'recipientCpfOrCnpj', 'recipientName', 'transhipmentPrice', 'actions'],

    columnsStopOptions: [
      {
        value: 'type',
        text: 'Tipo'
      },
      {
        value: 'cityName',
        text: 'Cidade'
      },
      {
        value: 'recipientCpfOrCnpj',
        text: 'CPF/CNPJ do Destinatário'
      },
      {
        value: 'recipientName',
        text: 'Nome do Destinatário'
      },
      {
        value: 'transhipmentPrice',
        text: 'Preço do Transbordo'
      },
      { value: 'actions', text: 'Ações' }
    ],

    columnsDeliveries: [
      'type',
      'numberCte',
      'authorizationDate',
      'costFreight',
      'deliveryForecast',
      'emissionDate',
      'senderName',
      'actions'
    ],

    columnsDeliveriesOptions: [
      {
        value: 'type',
        text: 'Tipo'
      },
      {
        value: 'numberCte',
        text: 'Número CTE'
      },
      {
        value: 'authorizationDate',
        text: 'Data de Autorização'
      },
      {
        value: 'costFreight',
        text: 'Custo do Frete'
      },
      {
        value: 'deliveryForecast',
        text: 'Previsão de Entrega'
      },
      {
        value: 'emissionDate',
        text: 'Data de Emissão'
      },
      {
        value: 'senderName',
        text: 'Enviado por'
      },
      { value: 'actions', text: 'Ações' }
    ],
    columnsNfe: ['type', 'number', 'price', 'weight', 'completionDate'],

    columnsNfeOptions: [
      {
        value: 'type',
        text: 'Tipo'
      },
      { value: 'number', text: 'Número NFE' },
      { value: 'price', text: 'Preço da NF' },
      { value: 'weight', text: 'Peso da NF' },
      { value: 'completionDate', text: 'Data de Conclusão' }
    ],
    nodes: []
  }),
  mounted() {
    this.fetchStops();
  },
  computed: {
    ...mapGetters('TranshipmentStore', ['getTranshipments']),
    ...mapState('TranshipmentStore', ['paginateTransfer']),
    page: {
      get() {
        return this.paginateTransfer.pageNumber;
      },
      set(value) {
        this.setPageNumberTransfer(value);

        this.fetchStops();
      }
    }
  },
  methods: {
    ...mapMutations('TranshipmentStore', ['setPageNumberTransfer']),

    ...mapActions('TranshipmentStore', [
      'fetchTranshipment',
      'fetchTranshipmentBetweenDeliverers',
      'fetchTranshipmentBetweenStops',
      'fetchTranshipmentBetweenDeliveriesPending',
      'fetchTranshipmentBetweenNfes',
      'setTransferDataDeliverers'
    ]),
    async fetchStops() {
      this.loadingStops = true;
      try {
        const data = await this.fetchTranshipmentBetweenStops(this.transhipmentId);
        this.nodes = data.map((item, index) => {
          return {
            key: `${index}`,
            data: {
              ...item,
              recipientCpfOrCnpj: this.transformCpfOrCnpj(item.recipientCpfOrCnpj),
              transhipmentPrice: this.transformPrice(item.transhipmentPrice),
              type: 'Parada'
            },
            children: [],
            type: 'Stops',
            open: false,
            selected: false
          };
        });
      } catch (err) {
        console.error(err);
      } finally {
        this.loadingStops = false;
      }
    },
    async onExpand(selected) {
      this.loadingStops = true;
      if (selected.type === 'Stops') {
        const stopKey = Number(selected.key);
        this.nodes[stopKey].open = !this.nodes[stopKey].open;

        try {
          const data = await this.fetchTranshipmentBetweenDeliveriesPending(selected.data.id);

          const newDeliveries = data.map((item, index) => {
            return {
              key: `${selected.key}-${index}`,
              data: {
                ...item,
                authorizationDate: this.transformDate(item.authorizationDate),
                deliveryForecast: this.transformDate(item.deliveryForecast),
                emissionDate: this.transformDate(item.emissionDate),
                type: 'Entrega'
              },
              children: [],
              type: 'Deliveries',
              open: false,
              selected: false
            };
          });
          if (this.nodes[stopKey].children.length === 0) {
            this.nodes[stopKey].children = newDeliveries;
          }

          if (selected.selected) {
            this.nodes[stopKey].children.map((item) => {
              item.selected = true;
              if (!this.selectedCheckbox.includes(item.data)) {
                this.selectedCheckbox.push(item.data);
              }
            });
          }
        } catch (err) {
          console.error(err);
        } finally {
          this.loadingStops = false;
        }
      }
      if (selected.type === 'Deliveries') {
        const stopIndex = Number(selected.key.split('-')[0]);
        const deliverIndex = Number(selected.key.split('-')[1]);
        this.nodes[stopIndex].children[deliverIndex].open = !this.nodes[stopIndex].children[deliverIndex].open;

        try {
          const statusesIds = [1, 2, 12, 3, 4, 14];
          const id = selected.data.id;
          const data = await this.fetchTranshipmentBetweenNfes({ id, statusesIds });

          const newNfe = data.map((item, index) => {
            return {
              key: `${selected.key}-${index}`,
              data: {
                ...item,
                completionDate: this.transformDate(item.completionDate),
                type: 'Nota Fiscal'
              },
              type: 'Nfe'
            };
          });

          this.nodes[stopIndex].children[deliverIndex].children = newNfe;
        } catch (err) {
          console.error(err);
        } finally {
          this.loadingStops = false;
        }
      }
    },
    changeSelectedCheckbox(item, children, shipmentIndex, cargoIndex, stopIndex) {
      this.selectedCheckbox = changeCheckbox(
        this.selectedCheckbox,
        item,
        children,
        shipmentIndex,
        cargoIndex,
        stopIndex,
        this.nodes[stopIndex]
      );
    },
    transformDate(date) {
      return maskData(date);
    },
    transformPrice(price) {
      return maskPrice(price);
    },
    transformCpfOrCnpj(str) {
      if (str.length === 11) {
        return maskCPF(str);
      }

      return maskCNPJ(str);
    }
  }
};
</script>

<style></style>
